const translation = {
  // Hero Section
  heroTitle: 'Connect to Internet Easily and Securely',
  heroSubtitle: 'Choose your preferred package and pay securely via Orange Money, Moov, MTN, or Wave',
  securePayment: 'Secure Payment',
  instantActivation: 'Instant Activation',
  support247: '24/7 Support',

  // Package Selection
  chooseYourPackage: 'Choose Your Package',
  packageDescription: 'Various packages to suit all your internet needs',
  
  basicPackage: 'Basic Package',
  oneHour: '1 Hour',
  basicFeature1: 'Excellent browsing speed',
  basicFeature2: 'Suitable for light usage',
  basicFeature3: 'Technical support available',

  standardPackage: 'Standard Package',
  sixHours: '6 Hours',
  standardFeature1: 'High browsing speed',
  standardFeature2: 'Watch videos in HD quality',
  standardFeature3: 'Suitable for work and study',
  standardFeature4: 'Priority technical support',

  premiumPackage: 'Premium Package',
  oneDay: 'Full Day',
  premiumFeature1: 'Ultra-fast browsing speed',
  premiumFeature2: 'Watch videos in 4K quality',
  premiumFeature3: 'Fast download and upload',
  premiumFeature4: 'Dedicated technical support',

  ultimatePackage: 'Ultimate Package',
  oneWeek: 'Full Week',
  ultimateFeature1: 'Maximum available speed',
  ultimateFeature2: 'Uninterrupted live streaming',
  ultimateFeature3: 'Online gaming without lag',
  ultimateFeature4: 'VIP technical support 24/7',
  ultimateFeature5: 'Top network priority',

  currency: 'CFA',
  popular: 'Most Popular',
  selectPackage: 'Select Package',
  selected: 'Selected',

  // Payment Methods
  choosePaymentMethod: 'Choose Payment Method',
  paymentDescription: 'Pay securely via your preferred payment method',
  phoneNumber: 'Phone Number',
  enterPhoneNumber: 'Enter your phone number',
  payNow: 'Pay Now',
  secureTransaction: 'Fully secure and encrypted transaction',
  paymentSuccess: 'Payment Successful!',
  paymentSuccessMessage: 'Your payment has been received and your package is being activated',
  activationMessage: 'You will receive a confirmation message within a few minutes',

  // Features
  whyChooseUs: 'Why Choose Us?',
  whyChooseUsDesc: 'We provide you with the best internet experience at competitive prices and excellent service',
  
  securePaymentTitle: 'Secure and Encrypted Payment',
  securePaymentDesc: 'We use the latest encryption technologies to protect your financial information and ensure transaction security',
  
  instantActivationTitle: 'Instant Activation',
  instantActivationDesc: 'Get internet immediately after payment completion without any waiting or delay',
  
  support247Title: '24/7 Technical Support',
  support247Desc: 'Technical support team available around the clock to help you anytime',
  
  multiplePaymentTitle: 'Multiple Payment Methods',
  multiplePaymentDesc: 'Pay the way that suits you via Orange Money, Moov, MTN, or Wave',
  
  highSpeedTitle: 'High Speed',
  highSpeedDesc: 'Enjoy high internet speeds suitable for all your browsing, streaming, and gaming needs',
  
  easyAccessTitle: 'Easy Access',
  easyAccessDesc: 'Simple and easy-to-use interface that enables you to connect to the internet in seconds',

  // Footer
  footerDescription: 'Leading platform for providing internet services in remote areas with flexible and secure payment methods',
  quickLinks: 'Quick Links',
  packages: 'Packages',
  payment: 'Payment',
  aboutUs: 'About Us',
  contactUs: 'Contact Us',
  paymentMethods: 'Payment Methods',
  contactInfo: 'Contact Information',
  address: 'Bamako, Mali',
  allRightsReserved: 'All Rights Reserved',

  // New translations for enhanced sections
  getStarted: 'Get Started',
  aboutUs: 'About Us',
  aboutTitle: 'Connecting Communities to the Digital World',
  aboutDesc: 'Leading platform providing internet services to remote areas with flexible and secure payment solutions',
  happyCustomers: 'Happy Customers',
  cities: 'Cities',
  uptime: 'Uptime',
  yearsExperience: 'Years Experience',
  ourMission: 'Our Mission',
  ourVision: 'Our Vision',
  ourValues: 'Our Values',
  missionContent: 'We strive to provide high-quality internet services at affordable prices to remote areas, focusing on easy access and secure payment through multiple methods suitable for all customers.',
  visionContent: 'To be the first choice for internet services in remote areas, and contribute to bridging the digital divide by providing reliable and fast connectivity for everyone.',
  valuesContent: 'We believe in transparency, quality, and innovation. We put our customers first and continuously work to improve our services to meet their evolving needs.',
  reliable: 'Reliable',
  secure: 'Secure',
  fast: 'Fast',
  affordable: 'Affordable',
  ourPartners: 'Our Partners',
  partnersTitle: 'Working with the Best',
  partnersDesc: 'Strategic partnerships with the best payment and technology service providers',
  orangeDesc: 'Reliable and fast payment service',
  moovDesc: 'Flexible and innovative payment solutions',
  mtnDesc: 'Secure and guaranteed electronic payment',
  waveDesc: 'Instant transfers with no fees',
  mikrotikDesc: 'Professional network solutions',
  mikhmonDesc: 'Advanced network management',
  learnMore: 'Learn More',
  customerReviews: 'Customer Reviews',
  reviewsDesc: 'Discover the experiences of our satisfied customers',
  customer1Name: 'Ahmed Mohamed',
  customer1Role: 'User for 2 years',
  customer1Comment: 'Excellent and fast service, payment is very easy via Orange Money. I recommend this platform to everyone!',
  customer2Name: 'Fatima Ali',
  customer2Role: 'New customer',
  customer2Comment: 'Finally found a reliable internet service in our area. Prices are reasonable and technical support is great.',
  customer3Name: 'Omar Hassan',
  customer3Role: 'User for 6 months',
  customer3Comment: 'Excellent speed and instant activation. Great experience from start to finish.',
  satisfaction: 'Customer Satisfaction',
  support: 'Technical Support',
  reliability: 'Reliability',

  // About Section Modal
  aboutUsDetails: 'About Us Details',
  ourStory: 'Our Story',
  ourStoryText: 'Our journey began with a simple vision: to provide reliable and affordable internet services to remote areas. Since our founding, we have successfully served over 50,000 customers in more than 15 cities, becoming the first choice for families and businesses looking for fast and secure internet connection.',
  ourMission: 'Our Mission',
  missionText: 'We strive to provide high-quality internet services at competitive prices, focusing on customer experience and continuous innovation in connectivity solutions.',
  ourVision: 'Our Vision',
  visionText: 'To be the leading company in providing internet services in remote areas, and contribute to bridging the digital divide through innovative and reliable solutions.',
  ourValues: 'Our Values',
  integrity: 'Integrity and Transparency',
  integrityText: 'We are committed to the highest standards of honesty and transparency in all our dealings with customers and partners.',
  innovation: 'Continuous Innovation',
  innovationText: 'We invest in the latest technologies to provide the best and most efficient solutions for our customers.',
  customerFirst: 'Customer First',
  customerFirstText: 'Customer satisfaction is our top priority, and we work to provide excellent support around the clock.',
  ourTeam: 'Our Team',
  ourTeamText: 'Our team consists of experts specialized in telecommunications and information technology, working passionately to provide the best services and solve any problems our customers may face.',
  close: 'Close',
};

export default translation;
